export const getCookies = (name_cookie) => {
    const all_cookies = document.cookie?.split('; ')

    const find_current_cookie = all_cookies.find(f => f.includes(name_cookie))?.split('=') || [null, null]
    // console.log(find_current_cookie)
    return {name: find_current_cookie[0], value: find_current_cookie[1]}

}
